import SalesCart from '@/components/SalePoint/SalesCart/SalesCart'
import CustomerForm from '@/views/Client/CustomerForm'
import PromoList from '@/views/Promos/PromoList'
import Test from '@/test'
import EmployeeForm from '@/views/Employee/EmployeeForm'
import ProductChange from '@/views/Change/ProductChange'
import TicketList from '@/views/TicketList/TicketList'
import MobileCart from '../../views/MobileCart/MobileCart.vue'
import MobileItemDetails from '../../views/MobileCart/MobileItemDetails.vue'
import MobileItemSearch from '../../views/Mobile/MobileItemSearch.vue'
import MobileCustomer from '../../views/Mobile/MobileCustomer.vue'
import MobileSalesList from '../../views/Mobile/MobileSalesList.vue'
import ReceivableList from '../../views/Mobile/ReceivableList'
import DispatchRequestList from '../../views/dispatchRequest/DispatchRequestList.vue'

export default [
    {
        path: '/',
        name: 'cart',
        component: SalesCart,
    },
    {
        path: '/mobile',
        name: 'mobileCart',
        component: MobileCart,
    },
    {
        path: '/mobile/details',
        name: 'mobileItemDetails',
        component: MobileItemDetails,
    },
    {
        path: '/mobile/search',
        name: 'mobileItemSearch',
        component: MobileItemSearch,
    },
    {
        path: '/mobile/customer',
        name: 'mobileCustomer',
        component: MobileCustomer,
    },
    {
        path: '/mobile/sales_list',
        name: 'groundSellerSalesList',
        component: MobileSalesList,
    },
    {
        path: '/mobile/receivable_list',
        name: 'receivableList',
        component: ReceivableList,
    },
    {
        path: '/cambio',
        name: 'cambio',
        component: ProductChange,
    },
    {
        path: '/cliente',
        name: 'cliente',
        component: CustomerForm,
    },
    {
        path: '/employee',
        name: 'empleado',
        component: EmployeeForm,
    },
    {
        path: '/promos',
        name: 'promos',
        component: PromoList,
    },
    {
        path: '/reimprimir',
        name: 'reimprimir',
        component: TicketList,
    },
    {
        path: '/solicitudes_despacho',
        name: 'dispatchRequestList',
        component: DispatchRequestList,
    },
]
